import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

// -- entities
import OpeningHour from 'PMT/entities/OpeningHour';

// -- views
import OpeningHourView from './OpeningHourView';

class OpeningHoursForDay extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    openingsHours: PropTypes.arrayOf(OpeningHour).isRequired,

    day: PropTypes.number.isRequired,

    // params: number (day), openingHour (OpeningHour)
    onDelete: PropTypes.func.isRequired,

    readOnly: PropTypes.bool
  };

  // -- actions
  onDelete = (openingHour: OpeningHour) => {
    this.props.onDelete(this.props.day, openingHour);
  };

  // -- renderers
  renderList() {
    const openingsHoursListView = [];

    const sortedOpeningHours = _.sortBy(
      this.props.openingsHours,
      ['asc'],
      (hour): number => {
        return hour.opening;
      }
    );

    let i = 0; // handle if there is same two hours.
    _.each(sortedOpeningHours, (openingHour: OpeningHour) => {
      openingsHoursListView.push(
        <OpeningHourView
          key={`${openingHour.opening}_${openingHour.closing}_${i}`}
          openingHour={openingHour}
          onDelete={this.onDelete}
          readOnly={this.props.readOnly}
        />
      );
      ++i;
    });

    return openingsHoursListView;
  }

  render() {
    return (
      <div className="opening_hours_for_day">
        {this.renderList()}
      </div>
    );
  }

}

export default OpeningHoursForDay;



// WEBPACK FOOTER //
// ./scripts/components/openingHours/OpeningHoursForDay.js